import React, { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router';

import { isUserLoggedIn, LoginScreen, StandardLoginScreenContents } from '@paragon/login-tools';
import { InlineNotification } from '@paragon/notification-tools';

import { useAppSelector } from './hooks';

export function AccountVerification() {
  const loggedInUser = useAppSelector((state) => isUserLoggedIn(state));
  const [accountCreatedInCurrentFlow, setAccountCreatedInCurrentFlow] = useState(false);

  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  if (loggedInUser && !accountCreatedInCurrentFlow) return <Navigate to="/" replace />;

  return (
    <LoginScreen>
      {email ? (
        <StandardLoginScreenContents
          verifyAccountEmail={email}
          onAccountCreated={() => setAccountCreatedInCurrentFlow(true)}
        />
      ) : (
        <InlineNotification type="error">Bad link.</InlineNotification>
      )}
    </LoginScreen>
  );
}
